export default "__VITE_ASSET__B5$nF9XN__"